// extracted by mini-css-extract-plugin
module.exports = {"heroHeader":"style-module__heroHeader___7zX5B"};